<template>
  <div class="form-box">
    <el-form
      :model="formModel"
      :ref="tempFromName"
      :rules="formRule"
      class="form-template"
      v-loading="loading"
    >
      <el-row>
        <span
          v-for="(column,index) in (formOptions && formOptions.columns)"
          :key="index"
        >
          <div
            v-if="column.type=='button'"
            class="column-button"
          >
            <el-button @click="column.callback">{{ column.label }}</el-button>
          </div>
          <div v-else>
            <el-col
              v-if="column.hidden == true?false:true"
              :span="column.isAllline ? 24 : (column.span||formOptions.span)"
              :style="column.style"
              v-show="column.isShow == null?true:column.isShow"
            >
              <el-row>
                <el-col
                  v-if="column.type=='title'"
                  :span=24
                >
                  <div class="column-title">{{ column.label }}</div>
                </el-col>
                <el-col
                  v-else
                  :span="column.isAllline ? (column.span||formOptions.span) : 24"
                >
                  <el-form-item
                    :label="column.label"
                    :prop="column.prop"
                    :class="[{'is-required':column.specialRule},column.class]"
                    :label-width="getLabelWidth(column)"
                    :error="column.error"
                    :style="column.style"
                  >
                    <!--输入框-->
                    <el-input
                      autocomplete="off"
                      v-if="column.type === columnType.input"
                      v-model.trim="formModel[column.prop]"
                      :maxlength="column.maxLength"
                      :minlength="column.minlength"
                      :placeholder="column.placeholder"
                      :disabled="column.disabled"
                      @change="valueChange(column)"
                    ></el-input>

                    <!--输入框-->
                    <el-input
                      autocomplete="new-password"
                      v-else-if="column.type === columnType.password"
                      type="password"
                      v-model.trim="formModel[column.prop]"
                    ></el-input>
                    <el-input
                      autocomplete="new-password"
                      v-else-if="column.type === columnType.repassword"
                      type="password"
                      v-model="formModel[column.prop]"
                    ></el-input>

                    <!--数字输入框-->
                    <el-input-number
                      autocomplete="off"
                      v-else-if="column.type === columnType.inputNumber"
                      v-model.trim="formModel[column.prop]"
                      :disabled=" column.disabled"
                      :placeholder="column.placeholder"
                      @change="valueChange(column)"
                      :precision="column.precision||undefined"
                      :min="column.min||undefined"
                      :max="column.max||undefined"
                    ></el-input-number>

                    <!--文本域-->
                    <el-input
                      type="textarea"
                      v-else-if="column.type === columnType.textarea"
                      :placeholder="column.placeholder"
                      v-model.trim="formModel[column.prop]"
                      :maxlength="column.maxLength"
                      :disabled=" column.disabled"
                    ></el-input>

                    <!--下拉框-->
                    <el-select
                      :class='{"multiple-select":column.multiple}'
                      v-else-if="column.type === columnType.select"
                      v-model="formModel[column.prop]"
                      placeholder="请选择"
                      @change="selectChange(column)"
                      :multiple="column.multiple || false"
                      :collapse-tags="column.collapseTags || false"
                      :disabled="column.disabled"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in column.data"
                        :key="item[column.uniqueKey]||item.value||item.id"
                        :label="item[column.labelKey]||item.label||item.name"
                        :title="item[column.labelKey]||item.label||item.name"
                        :value="item[column.uniqueKey]||item.value||item.id"
                      ></el-option>
                    </el-select>
                    <!--单选按钮-->
                    <el-radio-group
                      v-else-if="column.type === columnType.radio"
                      v-model="formModel[column.prop]"
                      @change="radioChange(column)"
                      :disabled="column.disabled"
                    >
                      <el-radio
                        v-for="item in column.data"
                        :key="item.label||item.name"
                        :label="item.label||item.name"
                        :value="item.label||item.name"
                      ></el-radio>
                    </el-radio-group>

                    <!--多选按钮-->
                    <el-checkbox-group
                      v-else-if="column.type === columnType.checkbox"
                      v-model="formModel[column.prop]"
                      @change="valueChange(column)"
                    >
                      <el-checkbox
                        v-for="item in column.data"
                        :key="item.value"
                        :label="item.label"
                      ></el-checkbox>
                    </el-checkbox-group>
                    <!--多选按钮-->
                    <el-checkbox-group
                      v-else-if="column.type === columnType.checkboxNew"
                      v-model="formModel[column.prop]"
                      @change="valueChange(column)"
                    >
                      <el-checkbox
                        v-for="(item,index) in column.data"
                        :key="index"
                        :label="item.id || item.value"
                      >{{ item.name || item.label }}</el-checkbox>
                    </el-checkbox-group>

                    <!---级联下拉框----->
                    <casader-select
                      :ref="column.prop"
                      v-else-if="column.type === columnType.casaderSelect"
                      :formModel="formModel"
                      @cascaderChange="cascaderChange"
                      :column="column"
                    ></casader-select>
                    <!--级联单选-->
                    <el-cascader
                      v-if="column.type === columnType.cascader"
                      v-model="formModel[column.prop]"
                      :options="column.data"
                      @change="valueChange(column)"
                      :props="{ expandTrigger: 'click',checkStrictly: true,
                          emitPath:column.emitPath||false,label:column.labelKey||'label',
                          value:column.valueKey||'id',children:column.childrenKey||'children',
                          }"
                    ></el-cascader>
                    <!--级联多选-->
                    <el-cascader
                      :options="column.data"
                      v-if="column.type === columnType.cascaderMultiple"
                      v-model="formModel[column.prop]"
                      :props=cascaderProp
                      collapse-tags
                      @change="valueChangeMultiple($event,column)"
                    >
                    <template slot-scope="{ node, data }">
                      <div v-if="column.data[0].label == data.label">
                        <el-checkbox v-model="isCheckedAll" @change="checkAll($event,column)"
                                     class="allSelectStyle">全选</el-checkbox>
                        <span>{{ data.label }}</span>
                      </div>
                    </template>
                  </el-cascader>
                    <!--开关-->
                    <el-switch
                      v-else-if="column.type === columnType.switch"
                      v-model="formModel[column.prop]"
                      @change="valueChange(column)"
                      :disabled="column.disabled"
                    ></el-switch>

                    <!--滑块-->
                    <el-slider
                      v-else-if="column.type === columnType.slider"
                      v-model="formModel[column.prop]"
                      :step="10"
                      show-stops
                    ></el-slider>

                    <!--时间选择器 可配置间隔-->
                    <el-time-select
                      v-else-if="column.type === columnType.timeSelect"
                      v-model="formModel[column.prop]"
                      :picker-options="{start: '00:00',step: '00:15',end: '23:00'}"
                      placeholder="选择时间"
                    ></el-time-select>
                    <!--任意时间点选择器-->
                    <el-time-picker
                      value-format="HH:mm:ss"
                      v-else-if="column.type === columnType.timePicker"
                      v-model="formModel[column.prop]"
                      :picker-options="{ selectableRange: '00:00:00 - 23:59:59'}"
                      placeholder="选择时间">
                    </el-time-picker>
                    <!--日期选择器-->
                    <el-date-picker
                      v-else-if="column.type === columnType.datePicker"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :disabled="column.disabled"
                      v-model="formModel[column.prop]"
                      type="date"
                      placeholder="选择日期"
                    ></el-date-picker>
                    <be-code
                      :ref="column.prop"
                      :column="column"
                      :disabled="column.disabled"
                      v-else-if="column.type === columnType.code"
                      @changeCode="changeCode"
                    ></be-code>
                    <!--商户号-->
                    <mchnt-no
                      :ref="column.prop"
                      :column="column"
                      :disabled="column.disabled"
                      v-else-if="column.type === columnType.mchntNo"
                    ></mchnt-no>
                    <!--日期时间选择器-->
                    <el-date-picker
                      v-else-if="column.type === columnType.dateTimePicker"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      @change="valueChange(column)"
                      :disabled="column.disabled"
                      v-model="formModel[column.prop]"
                      placeholder="选择日期时间"
                    ></el-date-picker>

                    <!--文件上传-->
                    <file-template
                      :ref="column.prop"
                      :column="column"
                      :disabled="column.disabled"
                      v-else-if="fileType.indexOf(column.type)>-1"
                    ></file-template>

                    <!--短信验证-->
                    <verification-code
                      :ref="column.prop"
                      :column="column"
                      :disabled="column.disabled"
                      v-else-if="column.type === columnType.verify"
                    ></verification-code>
                    <!--多个属性合集-->
                    <attribute-editor
                      :ref="column.prop"
                      :column="column"
                      v-else-if="column.type === columnType.attributeEditor"
                    ></attribute-editor>
                    <!--富文本-->
                    <rich-text-editor
                      :ref="column.prop"
                      v-else-if="column.type === columnType.richText"
                      :formData="formModel[column.prop]"
                    ></rich-text-editor>
                    <!--穿梭框-->
                    <el-transfer
                      v-else-if="column.type === columnType.transfer"
                      :filterable="column.filterable"
                      :filter-method="column.filterMethod"
                      :titles="column.titles"
                      :format="{
                        noChecked: '${total}',
                        hasChecked: '${checked}/${total}'
                      }"
                      v-model="formModel[column.prop]"
                      :data="column.data"
                    ></el-transfer>
                    <template v-else-if="column.type === columnType.slot">
                      <slot
                        name="fromSlot"
                        :column="column"
                      ></slot>
                    </template>

                    <!-- 地图 -->
                      <m-map
                        v-else-if="column.type === columnType.map"
                        :column="column"
                        :mapRow="{}">
                    </m-map>
                    <!-- 多选按钮组 -->
                    <check-list
                      :ref="column.prop"
                      v-else-if="column.type === columnType.checkList"
                      :column="column"
                    >
                    </check-list>

                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </div>
        </span>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="btn-box">
            <el-button
              type="primary"
              @click="submitForm"
              :loading="loading"
            >提交
            </el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import attributeEditor from "../controls/attributeEditor";
  import dateTimeRange from "../controls/dateTimeRange";
  import casaderSelect from "../controls/cascaderSelect";
  import checkList from "../controls/checkList";
  import beCode from "../controls/beCode";
  import mchntNo from "../controls/mchntNo";
  import mMap from "../controls/mapTemplate";
  import fileTemplate from "../controls/fileTemplate";
  import fromTemplate from "@/mixin/fromTemplate.js";

  export default {
    mixins: [fromTemplate],
    name: "formTemplate",
    components: {
      attributeEditor,
      dateTimeRange,
      casaderSelect,
      beCode,
      mchntNo,
      mMap,
      checkList,
      fileTemplate,
    },
    data() {
      return {
        isCheckedAll: true,
        cascaderProp: {
          checkStrictly: false,
          expandTrigger: 'click',
          multiple: true,
          emitPath: true,
        },
        formOptions: {},
        detailId: "",
        columnType: this.$utils.columnType,
        loading: false,
      };
    },
    props: {
      changeOptions: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    watch: {
      formModel: {
        handler(newData, oldData) {
          this.$store.commit(this.$utils.storeKeys.CURRENTFORM, this.formModel);
        },
        deep: true,
      },
    },
    methods: {
      // 自编码自动截取条码后6位
      changeCode(code) {
        this.formOptions.columns.forEach(v => {
          if (v.isSubstring) {
            if (code.length > 6) {
              this.formModel[v.prop] = code.substring((code.length - v.substringLength), code.length)
            } else {
              this.formModel.artNo = code
            }
          }
        })
      },
      // 及联选择器选择全部
      checkAll(val, column) {
        if (val) {
          this.cascaderProp.checkStrictly = false
          this.cascaderProp.emitPath = true
        } else {
          this.cascaderProp.checkStrictly = true
          this.cascaderProp.emitPath = false
        }
        this.getSelectData(column)
        this.formModel[column.prop] = []
        this.$forceUpdate()
      },
      getLabelWidth(column) {
        if (column.label.length == 0) {
          return "0px";
        } else if (column.labelWidth) {
          return column.labelWidth;
        } else if (this.formOptions.labelWidth) {
          return this.formOptions.labelWidth;
        } else {
          return "120px";
        }
      },
      clearData() {
        this.formOptions = {};
        this.detailId = "";
        this.formModel = {}; // 提交对象
        this.formRule = {}; //验证规则
      },
      initData(formOptions, id) {
        this.clearData();
        this.$nextTick(() => {
          this.detailId = id;
          if (Object.keys(formOptions).length == 0) return;
          switch (formOptions.formType) {
            case this.formType.insert: // 添加 初始化modal
              this.setOptionsData(formOptions);
              break;
            case this.formType.update:
              this.getDetail(formOptions);
              break;
            case this.formType.other:
              if (formOptions.url) {
                this.getDetail(formOptions);
              } else {
                this.formModel = formOptions.formData || {};
                this.setOptionsData(formOptions);
              }
              break;
            default:
              this.formModel = formOptions.formData || {};
              this.setOptionsData(formOptions);
              break;
          }
        });
        this.$emit("resetData");
      },

      // 实时获取详情
      getDetail(formOptions) {
        this.loading = true;
        this.$axios
          .fetchGet(
            formOptions.url +
            `?${formOptions.uniqueKey || "id"}=` +
            this.detailId,
            {}
          )
          .then((data) => {
            this.loading = false;
            if (data.code == 200 && data.data) {
              formOptions &&
              formOptions.columns.map((column) => {
                this.$set(this.formModel, column.prop, data.data[column.prop]);
              });
              let keys = Object.keys(data.data);
              keys.map((key) => {
                this.$set(this.formModel, key, data.data[key]);
              });
              this.$nextTick(() => {
                this.setOptionsData(formOptions);
              });
              this.$emit("getDetailSuccess", this.formModel);
            } else {
              // this.$message({type: "error", message: "获取信息出错!"});
              this.$notify({
                type: "error",
                title: '查询操作',
                message: '获取信息出错!',
                showClose: false,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            // this.$message({type: "error", message: "获取信息出错!"});
            this.$notify({
              type: "error",
              title: '查询操作',
              message: '获取信息出错!',
              showClose: false,
            });
            this.loading = false;
          });
      },

      // 点击提交
      submitForm() {
        let comData = this.getSpecialAttributes();
        if (comData === false) return;
        this.$refs[this.tempFromName].validate((valid) => {
          if (valid) {
            switch (this.formOptions.formType) {
              case this.formType.insert:
                this.insert();
                break;
              case this.formType.update:
                this.update();
                break;
              default:
                this.$emit("submit", this.formModel);
                console.log("submit default!");
                break;
            }
          } else {
            return false;
          }
        });
      },

      // 添加
      insert() {
        this.$loading({text: '提交中，请稍后。。。'})
        // this.loading = true;
        this.$axios
          .fetchPost(this.formOptions.url, this.formModel)
          .then((data) => {
            // this.loading = false;
            if (data.code == 200) {
              // this.$message({type: "success", message: "添加成功!"});
              this.$notify({
                type: "success",
                title: '新增操作',
                message: '成功',
                showClose: false,
              });
              this.$emit("success");
            } else {
              this.$notify({
                type: "error",
                title: '新增操作',
                message: data.msg,
                showClose: false,
              });
              // this.$message({message: data.msg, type: "error"});
            }
          })
          .catch((err) => {
            // this.loading = false;
            // this.$message({message: "添加出错", type: "error"});
            this.$notify({
              type: "error",
              title: '新增操作',
              message: '失败',
              showClose: false,
            });
          }).finally(() => {
          this.$loading({}).close()
        })
      },
      // 编辑
      update() {
        this.$loading({text: '提交中，请稍后。。。'})
        // this.loading = true;
        this.$axios
          .fetchPut(this.formOptions.url, this.formModel)
          .then((data) => {
            // this.loading = false;
            if (data.code == 200) {
              // this.$message({type: "success", message: "编辑成功!"});
              this.$notify({
                type: "success",
                title: '编辑操作',
                message: '成功',
                showClose: false,
              });
              this.$emit("success");
            } else {
              this.$notify({
                type: "error",
                title: '编辑操作',
                message: data.msg,
                showClose: false,
              });
              // this.$message({message: data.msg, type: "error"});
            }
          })
          .catch((err) => {
            // this.loading = false;
            this.$notify({
              type: "error",
              title: '编辑操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: data.msg, type: "编辑出错"});
          }).finally(() => {
          this.$loading({}).close()
        })
      },
      // 重置
      resetForm() {
        this.loading = false;
        this.$refs[this.tempFromName].resetFields();
        this.clearSpecialAttributes();
        this.isCheckedAll = true
        this.cascaderProp = {
          checkStrictly: false,
          expandTrigger: 'click',
          multiple: true,
          emitPath: true,
        }
      },
    },
  };
</script>
<style>
  .form-box .btn-box {
    text-align: center;
    margin-top: 15px;
  }

  .form-box .column-title {
    height: 20px;
    line-height: 20px;
    background-color: #efefef;
    padding: 10px;
    box-sizing: content-box;
    border-radius: 5px;
    padding-left: 20px;
    margin-bottom: 20px;
  }

  .form-box .column-button {
    display: inline-block;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/template/formTemplate.vue